import { RequestBuilder } from "../requestBuilder";
import {
  CreateProjectInputSchema,
  UpdateProjectInputSchema,
  ProjectIdParamsSchema,
  ProjectsSyncSchema,
  InvitationIdParamsSchema,
  AcceptInvitationInputSchema,
  UpdateInvitationInputSchema,
  CreateInvitationsInputSchema,
} from "./projectClient.types";
import { ProjectSchema, ProjectWithInvitesSchema, InvitationsSyncSchema, FocusedContextSchema, InvitationSchema, CreateInvitationsResponseSchema } from "@storytell/types";

export const ProjectsSyncRequestConfig = new RequestBuilder({
  path: () => "/projects-sync",
  responseSchema: ProjectsSyncSchema,
});

export const CreateProjectRequestConfig = new RequestBuilder({
  path: () => "/projects",
  responseSchema: ProjectWithInvitesSchema,
  bodySchema: CreateProjectInputSchema,
}).withMethod("POST");

export const DeleteProjectRequestConfig = new RequestBuilder({
  paramsSchema: ProjectIdParamsSchema,
  path: (params) => `/projects/${params.id}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);

export const UpdateProjectRequestConfig = new RequestBuilder({
  paramsSchema: ProjectIdParamsSchema,
  path: ({ id }) => `/projects/${id}`,
  responseSchema: ProjectSchema,
  bodySchema: UpdateProjectInputSchema,
}).withMethod("POST");

export const InvitationsSyncRequestConfig = new RequestBuilder({
  path: () => "/invitations-sync",
  responseSchema: InvitationsSyncSchema,
});

export const CreateInvitationsRequestConfig = new RequestBuilder({
  path: () => "/invitations",
  responseSchema: CreateInvitationsResponseSchema,
  bodySchema: CreateInvitationsInputSchema,
}).withMethod("POST");

export const AcceptInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}/accept`,
  responseSchema: FocusedContextSchema,
  bodySchema: AcceptInvitationInputSchema,
}).withMethod("PUT");

export const UpdateInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}`,
  responseSchema: InvitationSchema,
  bodySchema: UpdateInvitationInputSchema,
}).withMethod("POST");

export const DeleteInvitationRequestConfig = new RequestBuilder({
  paramsSchema: InvitationIdParamsSchema,
  path: ({ invitationId }) => `/invitations/${invitationId}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);
